import { connect } from 'react-redux';

import LanguageSelector from './component';

const mapStateToProps = ({ global: { lanData, lanList } }) => ({
	lanData,
	lanList,
});

export default connect(mapStateToProps)(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/molecules/LanguageSelector/index.js